import axios from "./axiosConfig";
import authHeader from "./auth-header";
import { API_URL } from "../utils/constants";
import { getApiErrorMessage } from "../utils/apiErrors";

class ContactBlacklistService {
  // Get all blacklist entries with pagination and filtering
  async getBlacklistEntries(filters = {}, page = 1, pageSize = 25) {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString()
    });

    if (filters.type && filters.type !== 'all') {
      params.append('type', filters.type);
    }

    if (filters.search && filters.search.trim()) {
      params.append('search', filters.search.trim());
    }

    try {
      const response = await axios.get(
        `${API_URL}rfq/contact-blacklist/?${params.toString()}`,
        { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching blacklist entries:", error);
      throw this.handleError(error);
    }
  }

  // Add new blacklist entry
  async addBlacklistEntry(entryData) {
    try {
      const response = await axios.post(
        `${API_URL}rfq/contact-blacklist/`,
        entryData,
        { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Error adding blacklist entry:", error);
      throw this.handleError(error);
    }
  }

  // Update blacklist entry (only reason can be updated)
  async updateBlacklistEntry(id, updateData) {
    try {
      const response = await axios.put(
        `${API_URL}rfq/contact-blacklist/${id}/`,
        updateData,
        { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating blacklist entry:", error);
      throw this.handleError(error);
    }
  }

  // Delete blacklist entry
  async deleteBlacklistEntry(id) {
    try {
      await axios.delete(
        `${API_URL}rfq/contact-blacklist/${id}/`,
        { headers: authHeader() }
      );
      return true;
    } catch (error) {
      console.error("Error deleting blacklist entry:", error);
      throw this.handleError(error);
    }
  }

  // Get single blacklist entry
  async getBlacklistEntry(id) {
    try {
      const response = await axios.get(
        `${API_URL}rfq/contact-blacklist/${id}/`,
        { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching blacklist entry:", error);
      throw this.handleError(error);
    }
  }

  // Get available contacts for blacklist selection
  async getAvailableContacts(searchQuery = '', page = 1, pageSize = 20) {
    const offset = (page - 1) * pageSize;
    const params = new URLSearchParams({
      limit: pageSize.toString(),
      offset: offset.toString()
    });

    if (searchQuery && searchQuery.trim()) {
      params.append('search', searchQuery.trim());
    }

    try {
      const response = await axios.get(
        `${API_URL}rfq/contacts/deduplicated/?${params.toString()}`,
        { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching available contacts:", error);
      throw this.handleError(error);
    }
  }

  // Get selected contacts by IDs
  async getSelectedContacts(contactIds) {
    if (!contactIds || !contactIds.length) {
      return { results: [] };
    }

    const params = new URLSearchParams({
      search_by_id: contactIds.join(',')
    });

    try {
      const response = await axios.get(
        `${API_URL}rfq/contacts/deduplicated/?${params.toString()}`,
        { headers: authHeader() }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching selected contacts:", error);
      throw this.handleError(error);
    }
  }

  // Handle API errors
  handleError(error) {
    return new Error(getApiErrorMessage(error) || "");
  }
}

export default new ContactBlacklistService();